"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = ensurePictureUrl;

var _createPictureUrlFromColor = _interopRequireDefault(require("@sift/skipper/helpers/createPictureUrlFromColor"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function ensurePictureUrl(src, theme) {
  if (!src || src.includes('profile-images/placeholders')) {
    return (0, _createPictureUrlFromColor["default"])(theme.palette.primary.dark);
  }

  return src;
}